// Generated by CoffeeScript 2.7.0
var App, getOrCreateElementById,
  indexOf = [].indexOf;

import Utilities from './utilities.js';

({getOrCreateElementById} = Utilities);

// Helpers for app
App = {
  stopEverything: function(event) {
    if (event) {
      event.stopImmediatePropagation();
      event.preventDefault();
      event.stopPropagation();
    }
    return false;
  },
  // 通过指定focus区域反向认定blur区域
  capturedBackdrop: function(callback, node = null) {
    var backdropID, eventType, fn;
    fn = function(event) {
      var _callback, arg, force_clean;
      arg = _.last($currentController.backdropArgs);
      // backdrop出栈处理
      while (arg && (!arg._node || !arg._node.contains(event.target))) {
        ({_callback} = arg);
        ({force_clean} = _callback(event) || {
          force_clean: true
        });
        if (!force_clean) {
          return;
        }
        $currentController.backdropArgs.pop();
        arg = _.last($currentController.backdropArgs);
      }
      if (!$currentController.backdropArgs.length) {
        return document.body.removeEventListener(eventType, fn, true);
      }
    };
    if ($currentController.backdropArgs == null) {
      $currentController.backdropArgs = [];
    }
    eventType = indexOf.call(window, 'touchend') >= 0 ? 'touchend' : 'click';
    if (_.isEmpty($currentController.backdropArgs)) {
      document.body.addEventListener(eventType, fn, true);
    }
    backdropID = {
      _node: node,
      _callback: callback
    };
    // 新打开的backdrop进入堆栈
    $currentController.backdropArgs.push(backdropID);
    return backdropID;
  },
  removeCapturedBackdropByID: function(id) {
    if (!$currentController.backdropArgs) {
      return;
    }
    return $currentController.backdropArgs = _.reject($currentController.backdropArgs, function(bd) {
      return bd === id;
    });
  },
  backdrop: function(node, callback, scrollable = false) {
    var backdrop, fn, oldZIndex, stop;
    oldZIndex = getComputedStyle(node).zIndex;
    // must larger than backdrop's zIndex(40)
    node.style.zIndex = 41;
    backdrop = getOrCreateElementById('backdrop', document.body, {
      className: 'backdrop'
    });
    stop = function(event) {
      return event.stopPropagation();
    };
    fn = function(event) {
      if (!scrollable) {
        event.preventDefault();
      }
      backdrop.removeEventListener('touchstart', fn, false);
      node.removeEventListener('touchstart', stop, false);
      node.style.zIndex = oldZIndex;
      callback();
      return document.body.removeChild(backdrop);
    };
    node.addEventListener('touchstart', stop, false);
    return backdrop.addEventListener('touchstart', fn, false);
  },
  disableScrollOnBody: function() {
    return DomMaster.wrap(document.body).addClass('disable-scroll');
  },
  enableScrollOnBody: function() {
    return DomMaster.wrap(document.body).removeClass('disable-scroll');
  }
};

export default App;
